import React, { FunctionComponent } from 'react';
import { Calc } from '../../../icons/components';
import { isNumber } from '../../../utils/validations';

interface InputProps {
    label?: string;
    name: string;
    defaultValue?: any;
    id: string;
    min?: number;
    icon?: boolean;
    onIconClick?: () => void;
    max?: number;
    placeholder?: string;
    register: any;
    value?: any;
    validation?: any;
    hasError?: any;
    type?: string;
}

const currencyToNumber = (value: any, mustBeNumber?: boolean) => {
    if (typeof value === 'number') return value;
    value = value ? value.replace('€ ', '').replace(/\./g, '') : null;

    if (value) {
        value = parseFloat(value);
        if (Math.round(value) !== value) {
            value = value.toFixed(2);
        }

        return Math.round(value);
    }
    return !mustBeNumber ? value : 0;
};

export const Input: FunctionComponent<InputProps> = ({
    label,
    name,
    defaultValue,
    id,
    placeholder,
    value,
    icon,
    onIconClick,
    register,
    min,
    max,
    validation,
    hasError,
    type = 'text',
}) => {
    let viewValue;

    validation = validation ? validation : {};

    if (type === 'currency') {
        validation.setValueAs = (v: any) => currencyToNumber(v);
        validation.validate = isNumber;
    }

    function setType(
        $event: React.FocusEvent<HTMLInputElement, Element>,
        type: string,
        action: string,
    ) {
        viewValue = value;

        if (type === 'currency') {
            // if it is a int (even 0) on blur we return it and Math.round
            // if it is not an int we return null
            // always round up

            if (action === 'blur') {
                viewValue = $event.target.value;
            } else {
                viewValue = currencyToNumber($event.target.value);
            }
            $event.target.type = action === 'focus' ? 'number' : 'text';
            $event.target.value =
                action === 'blur'
                    ? viewValue
                        ? '€ ' + viewValue.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
                        : null
                    : viewValue;
        }
    }
    return (
        <div
            className={`c-input ${hasError ? 'input--has-error' : ''} ${
                icon ? 'input--has-icon' : ''
            }`}>
            {label && (
                <label className="input__label" htmlFor={id}>
                    {label}
                </label>
            )}
            <input
                autoComplete="off"
                className="input__input"
                onFocus={(e) => setType(e, type, 'focus')}
                onBlurCapture={(e) => setType(e, type, 'blur')}
                type={type}
                min={type === 'number' || type === 'currency' ? min : undefined}
                max={type === 'number' || type === 'currency' ? max : undefined}
                id={id}
                placeholder={placeholder}
                defaultValue={defaultValue}
                {...register(name, validation)}
            />

            {icon && (
                <div className="ct-input-icon" onClick={onIconClick}>
                    <Calc height={22} width={18} />;
                </div>
            )}
        </div>
    );
};
